export enum Environment {
  Development = 'development',
  Test = 'test',
  Production = 'production',
  Local = 'local',
}
